import { useEffect, useState } from "react";
import api from "../lib/api";
import { Trophy, Flame, Award } from "lucide-react";
import { useAuth } from "../lib/auth";

export default function Leaderboard() {
  const [items, setItems] = useState([]);
  const { user } = useAuth();
  useEffect(() => { (async () => { const r = await api.get("/leaderboard"); setItems(r.data.items || []); })(); }, []);

  return (
    <div className="p-6 md:p-10" data-testid="leaderboard-page">
      <div className="mb-8 flex items-end justify-between flex-wrap gap-3">
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-zinc-500">Leaderboard</div>
          <h1 className="font-display font-black text-4xl tracking-tighter mt-1">This week&apos;s top climbers.</h1>
          <p className="text-zinc-600 mt-2 text-sm">Ranked by weekly points earned through resumes, skill gaps, and interviews.</p>
        </div>
      </div>

      <div className="card-flat overflow-hidden">
        <div className="grid grid-cols-12 px-5 py-3 text-[10px] uppercase tracking-[0.2em] text-zinc-500 border-b border-zinc-200">
          <div className="col-span-1">Rank</div>
          <div className="col-span-5">User</div>
          <div className="col-span-2">Points</div>
          <div className="col-span-2">Streak</div>
          <div className="col-span-2 text-right">Badges</div>
        </div>
        {items.length === 0 && <div className="p-8 text-center text-zinc-500 text-sm">No data yet — be the first on the board!</div>}
        {items.map(it => (
          <div key={it.user_id} className={`grid grid-cols-12 items-center px-5 py-4 border-b border-zinc-100 last:border-0 ${user?.id === it.user_id ? 'bg-[#0E7C66]/[0.04]' : ''}`} data-testid={`lb-row-${it.rank}`}>
            <div className="col-span-1">
              <div className={`h-7 w-7 rounded-full flex items-center justify-center text-xs font-mono font-bold ${
                it.rank === 1 ? 'bg-yellow-100 text-yellow-700' : it.rank === 2 ? 'bg-zinc-200 text-zinc-700' : it.rank === 3 ? 'bg-orange-100 text-orange-700' : 'bg-zinc-100 text-zinc-600'
              }`}>{it.rank}</div>
            </div>
            <div className="col-span-5 flex items-center gap-3">
              <div className="h-8 w-8 rounded-full bg-[#0A0A0A] text-white text-xs font-semibold flex items-center justify-center">
                {(it.name || 'U').slice(0,1).toUpperCase()}
              </div>
              <div>
                <div className="text-sm font-semibold">{it.name}{user?.id === it.user_id && <span className="ml-2 text-[10px] tag">You</span>}</div>
                <div className="text-xs text-zinc-500">Readiness {it.readiness_score || 0}/100</div>
              </div>
            </div>
            <div className="col-span-2 font-mono font-bold">{it.weekly_points}<span className="text-zinc-400 text-xs"> pts</span></div>
            <div className="col-span-2 flex items-center gap-1 text-sm"><Flame size={14} className="text-orange-500" /> {it.current_streak}d</div>
            <div className="col-span-2 flex items-center gap-1 justify-end">
              {(it.badges || []).slice(0,3).map((b,i)=>(<span key={i} className="h-6 w-6 rounded-full bg-zinc-100 border border-zinc-200 flex items-center justify-center"><Award size={12} /></span>))}
              {(it.badges || []).length > 3 && <span className="text-xs text-zinc-500">+{it.badges.length - 3}</span>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
